export default __webpack_public_path__ + "errorIcon.svg";